//
// Besselian Elements for Solar Eclipses from:
//   "Five Millennium Canon of Solar Eclipses: -1999 to +3000",
//      Fred Espenak and Jean Meeus, NASA/TP-2006-214141, October 2006
//
// eslint-disable-next-line @typescript-eslint/naming-convention
export function SE2024(): number[] {
  return [
    // 2024  4  8
    2460409.262840,  18.0,  -4.0,   4.0,    74.0,    74.0,
    -0.3182440,   0.5117116,  3.260e-05, -8.420e-06,
    0.2197640,   0.2709589, -5.950e-05, -4.660e-06,
    7.5862002,   0.0148440, -2.000e-06,
    89.5912170,  15.0040817,  0.000e-00,
    0.5358140,   0.0000618, -1.280e-05,
    -0.0102720,   0.0000615, -1.270e-05,
    0.0046683,   0.0046450,
  ];
}
 
